// Global variables for consistent usage across the application

// Company name - used in RotatingText component and elsewhere
export const COMPANY_NAME = "1000Shake";

// Contact information
export const CONTACT_INFO = {
  address: "1 rue André Maginot, 94350 Villiers sur Marne",
  phone: "+33 6 14 37 00 46",
  email: "contact@1000shake.com"
};

// Color palette
export const COLORS = {
  // Primary colors
  primary: "#6E9277", // Sage green accent color (was #0CE433)
  primaryHover: "#5B7A62", // Darker sage green for hover states
  
  // Background colors
  background: "#E1DBDB", // Light background (was #000000)
  cardBackground: "#D5CFCF", // Slightly darker card background
  overlayBackground: "rgba(225, 219, 219, 0.7)", // Light background with opacity
  
  // Text colors
  textPrimary: "#333333", // Dark text for light background (was white)
  textSecondary: "#555555", // Medium dark text (was light grey)
  textAccent: "#6E9277", // Sage green text accent
  creamText: "#E1DBDB", // Cream color for text on dark backgrounds
  
  // UI element colors
  navbarBackground: "#333333", // Dark navbar (was #E1DBDB)
  footerBackground: "#333333", // Dark footer (was #E1DBDB)
  buttonBackground: "#6E9277", // Sage green button
  buttonHover: "#5B7A62", // Darker sage green button hover
  buttonLightHover: "#f0ebeb", // Light hover for buttons
  buttonLightActive: "#e5e0e0", // Light active for buttons
  
  // Component-specific colors
  separatorInactive: "#E1DBDB50", // Inactive separator with transparency
  borderLight: "#555", // Light border color
  inactiveText: "#9CA3AF", // Inactive text color
  
  // Transparency variations
  creamTextWithOpacity: {
    light: "#E1DBDB26", // Cream text with 15% opacity
    medium: "#E1DBDB4D", // Cream text with 30% opacity
    dark: "#E1DBDB80", // Cream text with 50% opacity
  },
  
  // Footer specific colors
  footerGradient: "linear-gradient(to right, #1F2624, #5B7A62 50%, #1F2624)",
  footerText: "#F0EBEB",
  footerBorder: "#6E9277",
  
  // Gradients and effects
  cardGlow: "0 0 15px #6E9277", // Sage green glow for cards
  softGlow: "0 0 25px rgba(110, 146, 119, 0.5)", // Softer sage green glow
  headerGradient: "linear(to-r, #333333, #6E9277 50%, #333333)", // Dark to green gradient for headers
  textGradient: "linear(to-r, #333333, #6E9277 50%, #333333)", // Gradient for text elements
  lightTextGradient: "linear(to-r, #E1DBDB, #6E9277 50%, #E1DBDB)", // Light gradient for text on dark backgrounds
  
  // Status colors
  success: "#6E9277", // Sage green for success states
  error: "#C75252", // Darker red for error states on light background
  warning: "#D4A72D", // Darker yellow for warning states on light background
  info: "#3A77AA" // Darker blue for information states on light background
};

// Z-index levels for consistent stacking
export const Z_INDEX = {
  background: 0,
  base: 1,
  overlay: 10,
  modal: 20,
  tooltip: 30
};

// Responsive breakpoints 
export const BREAKPOINTS = {
  xs: "320px",
  sm: "576px",
  md: "768px",
  lg: "992px",
  xl: "1200px",
  xxl: "1400px"
};

// Animation durations
export const ANIMATION = {
  fast: "0.2s",
  medium: "0.3s",
  slow: "0.5s"
}; 